import { render, staticRenderFns } from "./webPanel.vue?vue&type=template&id=ff242cb0&scoped=true&"
import script from "./webPanel.vue?vue&type=script&lang=js&"
export * from "./webPanel.vue?vue&type=script&lang=js&"
import style0 from "./webPanel.vue?vue&type=style&index=0&id=ff242cb0&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ff242cb0",
  null
  
)

export default component.exports